export function print(content: string) {
  let printWindow = window.open('about:blank');

  if (printWindow == null) {
    return;
  }

  printWindow.document.open();
  printWindow.document.write('<html lang="en"><head></head><body>');
  printWindow.document.write(content);
  /**
   * Chrome's print dialog is in-browser and non-blocking. That means that when
   * calling `window.print();` Chrome does *not* halt execution but instead
   * continues to evaluate javascript, so we can't call `window.close()` right
   * after `window.print()`, otherwise the window will immediately close. Other
   * browsers do not behave the same way, as they use the OS print dialog.
   *
   * Additionally, firefox will not close the window if we call `window.close()`
   * in the same tick that `afterprint` fires. Thus, we need to execute
   * `window.close()` in the next tick for firefox.
   */
  printWindow.document.write(
    `<script type="text/javascript">
  window.addEventListener('afterprint', () => {
    setTimeout(() => window.close(), 0)
  });
</script>`,
  );
  printWindow.document.write('</body></html>');
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
}
